import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children: ReactNode;
  width?: 'fluid' | 'wide' | 'page';
  className?: string;
  pad?: boolean;
}

interface IStyledContainer {
  pad?: boolean;
  width?: 'fluid' | 'wide' | 'page' | string;
  [elem: string]: any;
}
const StyledContainer = styled.div<IStyledContainer>`
  max-width: ${(props) => props.width};
  padding: ${(props) => (props.pad ? '1rem' : '')};
  margin: 0 auto;
  transition: var(--standard-transition);
`;

export const Container = ({ children, width, pad, ...rest }: Props) => {
  let calculatedWidth = '768px';
  if (width === 'fluid') {
    calculatedWidth = '100%';
  }
  if (width === 'wide') {
    calculatedWidth = 'var(--wide-width)';
  }

  return (
    <StyledContainer width={calculatedWidth} pad={pad} {...rest}>
      {children}
    </StyledContainer>
  );
};
